export default function setTitleDomUtil (str) {
  document.title = str
}
